<template>
  <v-container fluid >
    <v-toolbar color="#FAFAFA" flat>
      <!--v-toolbar-side-icon @click="$emit('showHideMenu')"></v-toolbar-side-icon-->
      <v-toolbar-title >Artistas</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn light color="primary" flat to="/artistas/adicionar"><v-icon left>add</v-icon>Adicionar</v-btn>
    </v-toolbar>
  <v-divider></v-divider>
    <v-card flat>
      <v-card-title>
        <v-spacer></v-spacer>
        <v-text-field v-model="search" append-icon="search" label="Busca" single-line hide-details></v-text-field>
      </v-card-title>

      <v-data-table
        :headers="headers"
        :items="artists"
        :search="search"
        no-data-text="Nenhum artista encontrado."
        no-results-tex="Nenhum resultado encontrado."
      >
        <template slot="items" slot-scope="props">
          <td>{{ props.item.name }}</td>
          <td>{{ props.item.is_company == 1 ? 'sim':'não' }}</td>
          <td>0</td>
          <td class="text-xs-right">
            <v-menu offset-x left bottom>
              <v-btn icon slot="activator">
                <v-icon>more_vert</v-icon>
              </v-btn>
              <v-list>
                <v-list-tile  :to="{name:'artistas_editar', params:{ id:props.item.id} }">
                  <v-list-tile-title>Editar</v-list-tile-title>
                </v-list-tile>                
              </v-list>
            </v-menu>
          </td>
        </template>

        <v-alert
          slot="no-results"
          :value="true"
          color="error"
          icon="warning"
        >A sua busca por "{{ search }}" não teve resultados.</v-alert>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
import ArtistService from "../app/Rest/artist";

var artistService = null;

export default {
  data() {
    return {
      search: "",
      headers: [
        {
          text: "Nome",
          align: "left",
          sortable: true,
          value: "name"
        },
        {
          text: "Empresa",
          align: "left",
          sortable: true,
          value: "is_company"
        },
        {
          text: "Produtos",
          align: "left",
          sortable: true,
          value: "produtos"
        },
        {
          text: "Ações",
          align: "right",
          sortable: false,
          value: "acoes"
        }
      ],
      artists: []
    };
  },
  methods: {
    fetchRecords() {
      //console.log(process.env);
      artistService.search({}).then(this.fetchRecodsSuccess);
    },
    fetchRecodsSuccess(response) {
      if (Array.isArray(response.items)) {
        this.artists = response.items;
        return;
      }
      this.rows = [];
    }
  },
  created(){
     artistService = ArtistService.build();
  },
  mounted() {
    this.fetchRecords();
  }
};
</script>